import React from "react";
import { Search, Loader2 } from "lucide-react";

const POPULAR = ["Plumber", "Dentist", "Roofing", "HVAC", "Restaurant", "Law Firm", "Real Estate", "Auto Repair"];

const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD",
  "MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC",
  "SD","TN","TX","UT","VT","VA","WA","WV","WI","WY",
];

export default function SearchForm({ industry, city, state, setIndustry, setCity, setState, onSearch, loading, bulkMode }) {
  const submit = (e) => {
    e.preventDefault();
    if (industry.trim() && city.trim()) onSearch();
  };

  return (
    <div className="bg-white rounded-2xl border border-border p-6 shadow-sm">
      <form onSubmit={submit} className="grid md:grid-cols-[1fr_1fr_120px_auto] gap-3">
        <div>
          <label className="text-[12px] font-medium text-muted-foreground mb-1.5 block">Industry</label>
          <input
            value={industry}
            onChange={(e) => setIndustry(e.target.value)}
            placeholder="e.g. Plumber"
            className="w-full border border-border rounded-lg px-3.5 py-2.5 text-[14px] outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-100 transition"
          />
        </div>
        <div>
          <label className="text-[12px] font-medium text-muted-foreground mb-1.5 block">{bulkMode ? "Cities (comma-separated)" : "City"}</label>
          <input
            value={city}
            onChange={(e) => setCity(e.target.value)}
            placeholder={bulkMode ? "e.g. Sacramento, Roseville, Folsom" : "e.g. Sacramento"}
            className="w-full border border-border rounded-lg px-3.5 py-2.5 text-[14px] outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-100 transition"
          />
        </div>
        <div>
          <label className="text-[12px] font-medium text-muted-foreground mb-1.5 block">State</label>
          <select
            value={state}
            onChange={(e) => setState(e.target.value)}
            className="w-full border border-border rounded-lg px-3 py-2.5 text-[14px] outline-none focus:border-brand-500 bg-white h-[42px]"
          >
            {US_STATES.map((s) => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>
        <div className="flex items-end">
          <button
            type="submit"
            disabled={loading || !industry.trim() || !city.trim()}
            className="h-[42px] inline-flex items-center gap-2 bg-brand-600 text-white px-5 rounded-lg text-[14px] font-medium hover:bg-brand-700 disabled:opacity-50 transition-colors"
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : <Search size={16} />}
            {loading ? "Searching" : "Search"}
          </button>
        </div>
      </form>

      <div className="mt-4 flex flex-wrap items-center gap-2">
        <span className="text-[12px] text-muted-foreground">Popular:</span>
        {POPULAR.map((p) => (
          <button
            key={p}
            onClick={() => setIndustry(p)}
            className="text-[12px] px-2.5 py-1 rounded-full border border-border text-foreground/70 hover:border-brand-400 hover:text-brand-600 transition-colors"
          >
            {p}
          </button>
        ))}
      </div>
    </div>
  );
}
